import { FC } from 'react';
import { useRef, useState } from 'react';
import { Button, FormControl, FormLabel, Typography } from '@mui/joy';

interface IFileUpload {
  label: string;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  required?: boolean;
}

export const FileUpload: FC<IFileUpload> = ({ label, onChange, ...rest }) => {
  const inputRef = useRef<HTMLInputElement>(null);
  const [fileName, setFileName] = useState<string | null>(null);

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files && e.target.files[0]) {
      setFileName(e.target.files[0].name);
      if (onChange) onChange(e);
    }
  };

  return (
    <FormControl>
      {label && <FormLabel>{label}</FormLabel>}
      <input
        type="file"
        ref={inputRef}
        style={{ display: 'none' }}
        accept=".svg"
        onChange={(e) => {
          if (onChange) onChange(e);
          handleFileChange(e);
        }}
        {...rest}
      />
      <Button variant="outlined" onClick={() => inputRef.current?.click()}>
        {fileName ? `Выбран: ${fileName}` : 'Выбрать файл'}
      </Button>
      {/* {fileName && (
        <Typography level="body-sm" sx={{ mt: 1 }}>
          {fileName}
        </Typography>
      )} */}
    </FormControl>
  );
};
